goog.provide("shadow.js.shim.module$date_fns$isBefore$default");
shadow.js.shim.module$date_fns$isBefore$default = shadow.js.require(126, {}).default;
